import { useMutation } from "react-query";
import { AcceptOrRejectVacation } from "services/workSchedule";

export default function UseAcceptOrRejectVacation() {
  return useMutation(
    ({vacationId, status}: {vacationId: number; status: number}) => AcceptOrRejectVacation(vacationId, status),
  );
}
